import { render } from "./main.vue?vue&type=template&id=2d6e23f0&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=2d6e23f0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2d6e23f0"

export default script